import http from './http';
import notifier from '../_utils/notifier';

const authAPI = {
  getMe() { return http.get('users/me/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
  getMyBalance() { return http.get('users/balance/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
}


export default authAPI;

